import { WarehouseCreationForm } from 'components/Pages/Warehouses';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const WarehouseCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/armazens');
  }, [navigate]);

  return (
    <Scaffold>
      <WarehouseCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
